import PropTypes from 'prop-types';

export const PaxProps = PropTypes.shape({
    adults: PropTypes.number.isRequired,
    kids: PropTypes.number.isRequired,
    infants: PropTypes.number.isRequired,
});

export const PaxPropsDefault = {
    adults: 1,
    kids: 0,
    infants: 0,
};

export const TrainPaxPropsDefault = {
    seniors: 0,
    adults: 1,
    youth: 0,
    children: 0,
    infants: 0,
};

export const TrainPaxAgesPropsDefault = {
    youthAges: [],
    childrenAges: [],
};

export const TrainPaxProps = PropTypes.shape({
    seniors: PropTypes.number.isRequired,
    adults: PropTypes.number.isRequired,
    youth: PropTypes.number.isRequired,
    children: PropTypes.number.isRequired,
    infants: PropTypes.number,
});

export const TrainPaxAgesProps = PropTypes.shape({
    youthAges: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            age: PropTypes.number,
        })
    ).isRequired,
    childrenAges: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            age: PropTypes.number,
        })
    ).isRequired,
});
